import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=43c934b4&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=43c934b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c934b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43c934b4')) {
      api.createRecord('43c934b4', component.options)
    } else {
      api.reload('43c934b4', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=43c934b4&scoped=true&", function () {
      api.rerender('43c934b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/components/Header.vue"
export default component.exports